"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoLinksAndDescDisconnected = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _ReadMore = _interopRequireDefault(require("./ReadMore"));

var _ConnectButton = _interopRequireDefault(require("./ConnectButton"));

var _trackClick = require("../HOCs/trackClick");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/logoLinks.css") : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoLinksAndDesc = function LogoLinksAndDesc(_ref) {
  var listing = _ref.listing,
      toggleDetails = _ref.toggleDetails,
      userPrefs = _ref.userPrefs,
      detailsExpanded = _ref.detailsExpanded,
      listingDisabled = _ref.listingDisabled;
  var _userPrefs$userId = userPrefs.userId,
      userId = _userPrefs$userId === void 0 ? '' : _userPrefs$userId;
  var ID = listing.ID,
      _listing$core = listing.core,
      icon = _listing$core.icon,
      listingName = _listing$core.listingName,
      _listing$localized = listing.localized;
  _listing$localized = _listing$localized === void 0 ? {} : _listing$localized;
  var partnerListingURL = _listing$localized.partnerListingURL,
      _listing$localized$na = _listing$localized.name,
      name = _listing$localized$na === void 0 ? '' : _listing$localized$na,
      _listing$localized$ti = _listing$localized.title,
      title = _listing$localized$ti === void 0 ? '' : _listing$localized$ti,
      demonstrationURL = _listing$localized.demonstrationURL,
      brochureURL = _listing$localized.brochureURL,
      contactURL = _listing$localized.contactURL,
      details = _listing$localized.details,
      partnerImage = listing.images.partnerImage;
  var links = {
    partnerListingURL: partnerListingURL,
    demonstrationURL: demonstrationURL,
    brochureURL: brochureURL,
    contactURL: contactURL
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'LINK',
        v2_listing_id: ID,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  var renderLinks = function renderLinks(linksObj) {
    var output = [];

    if (linksObj.partnerListingURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.partnerListingURL,
        className: "ac-details-link",
        id: "ac-partner-listing-url",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "VisitOurWebsite"
      })), {
        value: 'PARTNER_LISTING_URL'
      }));
    }

    if (linksObj.demonstrationURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.demonstrationURL,
        id: "ac-demonstration-url",
        className: "ac-details-link",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "WatchDemo"
      })), {
        value: 'DEMONSTRATION_URL'
      }));
    }

    if (linksObj.brochureURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.brochureURL,
        className: "ac-details-link",
        target: "_blank",
        id: "ac-brochure-url"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Brochure"
      })), {
        value: 'BROCHURE_URL'
      }));
    }

    if (linksObj.contactURL) {
      output.push(trackClicked(_react.default.createElement("a", {
        href: linksObj.contactURL,
        id: "ac-contact-url",
        className: "ac-details-link",
        target: "_blank"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Support"
      })), {
        value: 'CONTACT_URL'
      }));
    }

    return output.map(function (el, i, arr) {
      return _react.default.createElement("span", {
        key: "".concat(i, "links")
      }, el, i < arr.length - 1 && ' | ');
    });
  };

  var renderReadMore = function renderReadMore() {
    return trackClicked(_react.default.createElement(_ReadMore.default, {
      text: details,
      isExpanded: detailsExpanded,
      expand: toggleDetails
    }), {
      value: 'READ_MORE'
    });
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-sm-9 col-xs-12"
  }, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-md-2 col-xs-3 imgDiv"
  }, _react.default.createElement("img", {
    alt: "Partner Image",
    className: "icon-image",
    src: icon || partnerImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg'
  })), _react.default.createElement("div", {
    className: "col-sm-6 col-xs-6 partner-name-and-title"
  }, _react.default.createElement("h1", {
    className: "ac-listing-name"
  }, name), _react.default.createElement("p", {
    className: "ac-listing-title"
  }, title))), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-10 read-more-area"
  }, renderReadMore(), renderLinks(links, ID, listingName)))), _react.default.createElement("div", {
    className: "clearfix visible-xs"
  }), _react.default.createElement("div", {
    className: "col-sm-3 col-xs-3"
  }, _react.default.createElement(_ConnectButton.default, {
    listing: listing,
    isDisabled: listingDisabled,
    userPrefs: userPrefs
  }))));
};

exports.LogoLinksAndDescDisconnected = LogoLinksAndDesc;

var mapStateToProps = function mapStateToProps(state) {
  return {
    userPrefs: state.userPrefs
  };
};

LogoLinksAndDesc.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object
  }).isRequired,
  toggleDetails: _propTypes.default.func.isRequired,
  userPrefs: _propTypes.default.shape({
    userId: _propTypes.default.string
  }),
  detailsExpanded: _propTypes.default.bool.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(LogoLinksAndDesc);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/LogoLinksAndDesc.js
// module id = 258
// module chunks = 0